import { SetPlatformNotifications } from '~/constants/mutations';
import { GetPlatformNotifications } from '~/constants/getters';

const defaultState = () => {
  return {
    platformNotifications: [],
  };
};

export const state = defaultState();

export const mutations = {
  [SetPlatformNotifications]: (state, data) => {
    state.platformNotifications = data;
  },
};

export const actions = {
  [SetPlatformNotifications]: ({ commit }, data) => {
    commit(SetPlatformNotifications, data);
  },
};

export const getters = {
  [GetPlatformNotifications]: (state) => {
    return state.platformNotifications;
  },
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
